import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import intersection from 'lodash/intersection';
import categoryQuery from '~/graphql/category.gql';
import categoriesQuery from '~/graphql/categories.gql';
import productsQuery from '~/graphql/products.gql';
import customizeProductQuery from '~/graphql/customizeProduct.gql';
import productPricesQuery from '~/graphql/product/prices.gql';
import TYPES from '~/const/editorial';
import { fetchDocumentsById } from '~/services/editorial';
var QUERIES = {
  productPrices: productPricesQuery,
  products: productsQuery,
  category: categoryQuery,
  categories: categoriesQuery,
  customized: customizeProductQuery
};

var componentList = () => {
  var paths = TYPES.filter(e => e.path);
  var slices = TYPES.filter(e => e.slices).map(e => e.slices).reduce((e, f) => e.concat(f), []);
  return [...paths, ...slices];
};

var typeDefinition = alias => {
  if (alias === 'null') {
    // When the alias is not defined in Prismic, it matches 'null' (/FR/fr/e/null/...)
    // In this case, we expect a 404
    return null;
  }

  return TYPES.find(e => e.aliases.includes(alias)) || TYPES.find(e => e.type === 'generic');
};

var sliceDefinition = (definition, slice) => definition.slices.find(e => e.name === slice.slice_type);

var supportedSlices = (definition, slices) => {
  var existing = definition.slices.map(e => e.name);
  var defined = slices.map(e => e.slice_type);
  return slices.filter(e => intersection(existing, defined).includes(e.slice_type));
};

var buildCatalogPayload = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (_ref, slice, client, locale) {
    var {
      query,
      handler
    } = _ref;
    var {
      data
    } = yield client.query({
      query: QUERIES[query],
      variables: _objectSpread({
        locale
      }, handler(slice))
    });
    return data;
  });

  return function buildCatalogPayload(_x, _x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var buildEditorialArticle = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (slice, store) {
    var {
      results
    } = yield fetchDocumentsById(store, [slice.primary.article.id]);
    return results;
  });

  return function buildEditorialArticle(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

var buildSlices = (definition, _ref4, client, store) => {
  var {
    body
  } = _ref4;
  var currentSlices = supportedSlices(definition, body);
  return Promise.all(currentSlices.map( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(function* (slice, position) {
      var {
        path,
        additional,
        article
      } = sliceDefinition(definition, slice);
      return {
        position,
        path,
        type: slice.slice_type,
        payload: {
          editorial: slice,
          catalog: additional ? yield buildCatalogPayload(additional, slice, client, store.state.i18n.currentLocale.iso) : null,
          article: article ? yield buildEditorialArticle(slice, store) : null
        }
      };
    });

    return function (_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }()));
};

export { componentList, typeDefinition, buildSlices };